import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Footer, FooterButtons, SocialMediaButtons } from '../LayoutStyles'

const SocialFacebook = require('./facebook.svg')
const SocialLinkedIn = require('./linkedin.svg')
const SocialYoutube = require('./youtube.svg')

const LayoutFooter = () => (
  <Switch>
    <Route exact={true} path="/">
      <Footer>
        <div className="center-content">
          <FooterButtons>
            <a href="https://www.peikko.com" target="_blank">
              <strong>www.peikko.com</strong>
            </a>{' '}
            | <a target="_blank" href="https://www.peikko.com/privacy-policy/">
              Privacy policy
            </a>,{' '}
            <a target="_blank" href="https://www.peikko.com/legal-notice/">
              Legal notice
            </a>{' '}
            and{' '}
            <a
              target="_blank"
              href={
                process.env.PUBLIC_URL +
                '/legal/Peikko_Group_Corporation_SAAS_AGREEMENT.pdf'
              }
            >
              User agreement
            </a>.
          </FooterButtons>
          <div className="spacer" />
          <SocialMediaButtons>
            <a href="https://www.facebook.com/peikkogroup/" target="_blank">
              <img src={SocialFacebook} />
            </a>
            <a
              href="https://www.linkedin.com/company/peikko-group/"
              target="_blank"
            >
              <img src={SocialLinkedIn} />
            </a>
            <a
              href="https://www.youtube.com/user/PeikkoGroupCorp"
              target="_blank"
            >
              <img src={SocialYoutube} />
            </a>
          </SocialMediaButtons>
        </div>
      </Footer>
    </Route>
  </Switch>
)

export default LayoutFooter



// WEBPACK FOOTER //
// ./src/Components/Layout/LayoutFooter/index.tsx